import { Avatar, Button, Card, Col, ConfigProvider, Flex, Form, Row, Space, Spin, Table } from "antd";
import { useForm } from "antd/es/form/Form";
import { FormInputNumber } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as CalculatorIcon } from "../../../assets/icon/calculatorIcon.svg";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { ReactComponent as HistoryIcon } from "../../../assets/icon/historyIcon.svg";

function EmployeeSalaryIncomDeduction({
  incomeDeduction = {},
  onSetupIncomeDeduction = () => { },
  getModal = () => { },
  getHistoryModal = () => { },
  onSubmit = () => { },
  setIsModalOpenHistory = () => { },
  calculateNetIncomeFn = () => { },
  isAmountVisible = false,
  setIsAmountVisible = () => { },
  previewPaySlip = () => { },
  dataIncome = [],
  dataDeduct = [],
  setDataIncome = () => { },
  setDataDeduct = () => { },
  isLoading = false
}) {
  const { t, i18n } = useTranslation();
  const [totalIncome, setTotalIncome] = useState();
  const [totalDeduct, setTotalDeduct] = useState();
  const [totalNetIncome, setTotalNetIncome] = useState((Number(totalIncome) || 0) - (Number(totalDeduct) || 0));
  const [formUse] = useForm();
  const { roles } = useSelector((state) => state.company);
  const calculateTotalIncome = useCallback(() => {
    const sum = (Number(totalIncome) || 0) - (Number(totalDeduct) || 0)
    setTotalNetIncome(sum)
  }, [totalIncome, totalDeduct])
  const checkDisableVisible = () => {
    return roles?.includes("ACCESS_DATA_SECURITY|EMPLOYEE|INCOME_DEDUCTION") ? false : true
  }
  useEffect(() => {
    if (incomeDeduction) {
      const sumIncome = dataIncome
        ?.filter(o => o.amount)
        ?.reduce?.((sum, o) => sum + Number(o.amount), 0);
      const sumDeduct = dataDeduct
        ?.filter(o => o.amount)
        ?.reduce?.((sum, o) => sum + Number(o.amount), 0);

      setTotalIncome(sumIncome)
      setTotalDeduct(sumDeduct)
      setTotalNetIncome((Number(totalIncome) || 0) - (Number(totalDeduct) || 0))
    }

  }, [incomeDeduction, totalIncome, totalDeduct, dataIncome, totalDeduct])

  const [newDataIncome, setNewDataIncome] = useState([]);
  const [newDataDeduct, setNewDataDeduct] = useState([]);

  useEffect(() => {
    const incomeUpdates = dataIncome.map(obj => ({ [obj.income.code]: obj.amount }));
    setNewDataIncome(incomeUpdates);

    const deductUpdates = dataDeduct.map(obj => ({ [obj.deduction.code]: obj.amount }));
    setNewDataDeduct(deductUpdates);
  }, [dataIncome, dataDeduct]);



  useEffect(() => {
    formUse.setFieldsValue({
      ...Object.assign({}, ...newDataDeduct, ...newDataIncome)
    });
  }, [newDataIncome, newDataDeduct]);

  const handleToggleVisibility = () => {
    setIsAmountVisible(prevState => !prevState);
  };

  const columnIncome = [
    {
      title: t("employee.label.income"),
      dataIndex: 'code',
      key: 'code',
      render: (_, record) => {
        return record?.income?.code
      }
    },
    {
      title: t("employee.label.income"),
      dataIndex: 'income',
      key: 'income',
      // width: "300px",
      render: (_, record) => {
        if (record?.income?.code == "I01")
          return i18n.language === 'en' ? record?.income?.nameEn + ` ( ${record?.incomeType?.incomeNameEn} ${((record?.deductionWithholdingTax || '') + (record?.deductionWithholdingTax ? "%" : ''))} ` : record?.income?.name + ` ( ${record?.incomeType?.incomeName} ${((record?.deductionWithholdingTax || '') + (record?.deductionWithholdingTax ? "%" : ''))} ) `
        return i18n.language === 'en' ? record?.income?.nameEn : record?.income?.name
      },
    },
    {
      title: t("employee.label.period"),
      dataIndex: 'periodIncome',
      key: 'periodIncome',
      width: "100px",
      render: (_, record) => {
        return i18n.language === 'en' ? record?.income?.frequencyOfPayment?.commonTypeNameEn ?? record?.income?.frequencyOfPayment?.nameEn : record?.income?.frequencyOfPayment?.commonTypeName ?? record?.income?.frequencyOfPayment?.name
      }
    },
    {
      title: t("dashboard.label.amount"),
      dataIndex: 'amount',
      key: 'amount',
      width: "30%",
      render: (_, record) => {

        return (
          // <Flex justify="center">
          //   {isAmountVisible ? (record?.amount ? (
          //     <InputNumber
          //       name="amount"
          //       value={record?.amount ? get2DecimalPointsWithCommas(record?.amount) : 0}  // Show the formatted value
          //       formatter={(value) =>
          //         value ? `${ parseFloat(value).toFixed(2) } `.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0.00'
          //       }
          //       parser={(value) => parseFloat(value.replace(/,/g, '')) || 0}
          //       onChange={(value) => {
          //         let change = dataIncome?.map((o) => {
          //           if (o?.income?.id === record?.income?.id) {
          //             return {
          //               ...o,
          //               amount: value
          //             };
          //           } else {
          //             return o;
          //           }
          //         });

          //         const sumIncome = change
          //           ?.filter(o => o.amount)
          //           .reduce((sum, o) => sum + Number(o.amount), 0);

          //         setDataIncome(change);
          //         setTotalIncome(sumIncome);
          //       }}
          //       style={{ borderRadius: "8px", textAlignLast: "center", width: "80%" }}
          //       disabled={record?.income?.code === 'I01'}
          //       controls={false}
          //     />
          //   ) : "xxx.xxx") : (
          //     <span>xxx.xxx</span>  // Render "xxx.xxx" when input is hidden
          //   )}
          // </Flex>
          <FormAntd initialValues={{ [record?.income?.code]: parseFloat(record?.amount) }} form={formUse}>
            <Form.Item>
              <Flex justify="center">
                {isAmountVisible ?
                  <FormInputNumber
                    name={record?.income?.code}
                    handleFix={true}
                    onChange={(value) => {
                      let change = dataIncome?.map((o) => {
                        if (o?.id === record?.id) {
                          return {
                            ...o,
                            amount: value,
                            modified: "Y"
                          };
                        } else {
                          return o;
                        }
                      });

                      const sumIncome = change
                        ?.filter(o => o.amount)
                        ?.reduce((sum, o) => sum + Number(o.amount), 0);
                      setDataIncome(change);
                      setTotalIncome(sumIncome);
                    }}
                    style={{ borderRadius: "8px", textAlignLast: "center", width: "80%" }}
                    disabled={record?.income?.code === 'I01'}
                    controls={false}
                    maxLength={22}
                  />
                  : (
                    <span name={record?.code} key={record?.code}>{record?.amount}</span>
                  )}
              </Flex>
            </Form.Item>
          </FormAntd>
        )
      }
    }
  ]

  const columnDeduct = [
    {
      title: t("employee.label.deduction"),
      dataIndex: 'code',
      key: 'code',
      render: (_, record) => {
        return record?.deduction?.code
      }
    },
    {
      title: t("employee.label.deduction"),
      dataIndex: 'deduction',
      key: 'deduction',
      render: (_, record) => {
        return i18n.language === 'en' ? record?.deduction?.nameEn : record?.deduction?.name
      }
    },
    {
      title: t("employee.label.period"),
      dataIndex: 'periodDeduction',
      key: 'periodDeduction',
      render: (_, record) => {
        return i18n.language === 'en' ? record?.deduction?.frequencyOfPayment?.commonTypeNameEn ?? record?.deduction?.frequencyOfPayment?.nameEn : record?.deduction?.frequencyOfPayment?.commonTypeName ?? record?.deduction?.frequencyOfPayment?.name
      }
    },
    {
      title: t("dashboard.label.amount"),
      dataIndex: 'amount',
      key: 'amount',
      width: "30%",
      render: (_, record) => {
        console.log("record.modified == 'M' ?  : null", record, record.modified == 'M' ? "M" : null);
        return (
          // <Flex justify="center">
          //   {isAmountVisible ? (record?.amount ? (
          //     <InputNumber
          //       name="amount"
          //       value={record?.amount ? get2DecimalPointsWithCommas(record?.amount) : 0}  // Show the formatted value
          //       formatter={(value) =>
          //         value ? `${ parseFloat(value).toFixed(2) } `.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0.00'
          //       }
          //       parser={(value) => parseFloat(value.replace(/,/g, '')) || 0}
          //       onChange={(value) => {
          //         let change = dataDeduct?.map((o) => {
          //           if (o?.deduction?.id === record?.deduction?.id) {
          //             return {
          //               ...o,
          //               amount: value
          //             }
          //           } else {
          //             return o
          //           }
          //         })
          //         const sumDeduct = change
          //           ?.filter(o => o.amount)
          //           .reduce((sum, o) => sum + Number(o.amount), 0);
          //         setDataDeduct(change)
          //         setTotalDeduct(sumDeduct)
          //       }}
          //       style={{ borderRadius: "8px", textAlignLast: "center", width: "80%" }}
          //       disabled={!isAmountVisible || record?.deduction?.code === 'D01' || record?.deduction?.code === 'D02'}
          //       controls={false}
          //     />
          //   ) : "xxx.xxx") : (
          //     <span>xxx.xxx</span>  // Render "xxx.xxx" when input is hidden
          //   )}
          // </Flex>
          <FormAntd initialValues={{ [record?.deduction?.code]: record?.amount }} form={formUse}>
            <Flex justify="center">
              {isAmountVisible ?
                <Space size={5}>
                  {(record.modified == 'Y' && record?.deduction?.code?.match("(D14|D11|D01|D13|D12|D02)")) ? <Avatar size={20}>M</Avatar> : null}
                  <FormInputNumber
                    // addonBefore={record.modified == 'Y' ? "M" : null}
                    name={record?.deduction?.code}
                    handleFix={true}
                    onChange={(value) => {
                      console.log("dataDeduct", dataDeduct, record);
                      let change = dataDeduct?.map((o) => {
                        if (o?.id === record?.id) {
                          return {
                            ...o,
                            amount: value,
                            modified: value == 0 ? "N" : "Y"
                          };
                        } else {
                          return o;
                        }
                      });

                      const sumDeduct = change
                        ?.filter(o => o.amount)
                        .reduce((sum, o) => sum + Number(o.amount), 0);
                      setDataDeduct(change)
                      setTotalDeduct(sumDeduct)
                    }}
                    style={{ borderRadius: "8px", textAlignLast: "center", width: "80%" }}
                    // disabled={!isAmountVisible || record?.deduction?.code === 'D01' || record?.deduction?.code === 'D02'}
                    disabled={!isAmountVisible}
                    controls={false}
                    maxLength={22}
                  />
                </Space>
                : (
                  <span name={record?.code} key={record?.code}>{record?.amount}</span>
                )}
            </Flex>

          </FormAntd>

        )
      }
    }
  ]
  // console.log("dataIncome.map(o => o.amount).reduce((o1, o2) => o1 + o2))", dataIncome.map(o => Number(o.amount)).reduce((o1, o2) => o1 + o2));

  const getTable = useCallback(() => {
    return (
      <Flex vertical style={{ rowGap: "20px" }}>
        <Row justify={"end"} style={{ gap: "10px" }}>
          <Button style={{ width: "max-content", height: "44px", borderRadius: "8px", padding: "10px 16px", color: "#344054" }}
            onClick={() => onSetupIncomeDeduction("taxComputation")}>
            <Flex align="center" justify="center" gap={8}>
              <CalculatorIcon />
              {t("employee.label.tax_Computation")}
            </Flex>
          </Button>
          <Button disabled={!isAmountVisible} onClick={() => previewPaySlip({
            incomes: dataIncome,
            deductions: dataDeduct,
            totalIncome: totalIncome,
            totalDeduct: totalDeduct,
            totalNetIncome: totalNetIncome
          })} style={{ width: "max-content", height: "max-content", borderRadius: "8px", padding: "10px 16px" }}>
            <span style={{ color: "#344054" }}> {t("employee.label.payslip_preview")}</span>
          </Button>
          <Button onClick={() => setIsModalOpenHistory(true)} style={{ width: "max-content", height: "44px", borderRadius: "8px", padding: "10px 16px" }} disabled={true}>
            <Flex align="center" justify="center" gap={8}>
              <HistoryIcon />
              <span style={{ color: "#344054" }}>{t("becash.label.history")}</span>
            </Flex>
          </Button>
          <Button style={{ width: "max-content", height: "44px", borderRadius: "8px", padding: "10px 16px" }}
            icon={isAmountVisible ? <EyeHideIcon /> : <EyeIcon />}
            onClick={handleToggleVisibility}
            disabled={checkDisableVisible()}
          />
        </Row>

        <Row justify="space-between" >
          <Col span={8} style={{ display: "flex", paddingRight: "4px" }}>
            <Card style={{ borderRadius: "12px", border: "solid 1px #EAECF0", flex: 1 }}>
              <Flex vertical style={{ rowGap: "8px", height: "100%" }}>
                <span style={{ color: "#667085", fontSize: "12px" }}>{t("employee.total_income")}</span>
                {/* <span style={{ fontSize: "30px" }}>{isAmountVisible ? (incomeDeduction?.totalIncome ? get2DecimalPointsWithCommas(incomeDeduction?.totalIncome) : "XXXX.XX") : "XXXX.XX"}</span> */}
                <span style={{ fontSize: "30px" }}>{isAmountVisible ? (dataIncome ? get2DecimalPointsWithCommas(dataIncome?.map?.(o => Number(o.amount ?? 0))?.reduce?.((o1, o2) => o1 + o2, 0)) : "0.00") : incomeDeduction?.totalIncome}</span>
              </Flex>
            </Card>
          </Col>

          <Col span={8} style={{ display: "flex", padding: "0px 4px" }}>
            <Card style={{ borderRadius: "12px", border: "solid 1px #EAECF0", flex: 1 }}>
              <Flex vertical style={{ rowGap: "8px", height: "100%" }}>
                <span style={{ color: "#667085", fontSize: "12px" }}>{t("employee.total_deduction")}</span>
                {/* <span style={{ fontSize: "30px" }}>{isAmountVisible ? (incomeDeduction?.totalDeduction ? get2DecimalPointsWithCommas(incomeDeduction?.totalDeduction) : "XXXX.XX") : "XXXX.XX"}</span> */}
                <span style={{ fontSize: "30px" }}>{isAmountVisible ? (dataDeduct ? get2DecimalPointsWithCommas(dataDeduct?.map?.(o => Number(o.amount ?? 0))?.reduce?.((o1, o2) => o1 + o2, 0)) : "0.00") : incomeDeduction?.totalDeduction}</span>
              </Flex>
            </Card>
          </Col>

          <Col span={8} style={{ display: "flex", paddingLeft: "4px" }}>
            <Card
              style={{
                borderRadius: "12px",
                border: "solid 1px #EAECF0",
                flex: 1,
              }}
            >
              <Flex vertical style={{ rowGap: "12px", height: "100%" }}>
                <span style={{ color: "#667085", fontSize: "12px" }}>{t("employee.cal_net_income")}</span>
                <span style={{ fontSize: "30px" }}>
                  {/* {isAmountVisible ? (incomeDeduction?.netIncome ? get2DecimalPointsWithCommas(incomeDeduction?.netIncome) : "XXXX.XX") : "XXXX.XX"} */}
                  {isAmountVisible ? (incomeDeduction?.netIncome ? get2DecimalPointsWithCommas(
                    dataIncome.map(o => Number(o.amount ?? 0))?.reduce((o1, o2) => o1 + o2, 0)
                    -
                    dataDeduct.map(o => Number(o.amount ?? 0))?.reduce((o1, o2) => o1 + o2, 0)
                  ) : "0.00") : incomeDeduction?.netIncome}
                </span>
                <Button type="primary"
                  // onClick={calculateTotalIncome}
                  style={{ height: "40px", borderRadius: "8px", backgroundColor: isAmountVisible ? "var(--button-color)" : null, padding: "8px 16px", color: isAmountVisible ? "white" : null }}
                  disabled={!isAmountVisible}
                  onClick={() =>
                    calculateNetIncomeFn({
                      incomes: dataIncome,
                      deductions: dataDeduct
                    })}
                >
                  <Flex align="center" justify="center" gap={8}>
                    <CreateIcon />
                    {t("employee.cal_salary")}
                  </Flex>
                </Button>
              </Flex>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col span={12} style={{ paddingRight: "8px", display: "flex" }}>
            <Card style={{ border: "solid 1px #EAECF0", borderRadius: "12px", flex: 1 }}>
              <Flex vertical style={{ rowGap: "16px" }}>
                <Row justify="space-between" align="middle">
                  <span style={{ fontSize: "18px", fontWeight: "bold", color: "#313131" }}>
                    {t("employee.label.income")}
                  </span>
                  <Button disabled={!isAmountVisible} icon={<CreateIcon color="#344054" />} style={{ height: "44px", width: "44px", borderRadius: "8px" }} onClick={() => onSetupIncomeDeduction("income")} />
                </Row>
                <ConfigProvider
                  theme={{
                    components: {
                      Table: {
                        headerBg: "#F1FBFC",
                        headerBorderRadius: "12px",
                        headerColor: "#667085",
                      },
                    },
                  }}
                >
                  <Table columns={columnIncome} dataSource={dataIncome} pagination={false} rowKey="income.code" />
                </ConfigProvider>
              </Flex>
            </Card>
          </Col>
          <Col span={12} style={{ paddingLeft: "8px", display: "flex" }}>
            <Card style={{ border: "solid 1px #EAECF0", borderRadius: "12px", flex: 1 }}>
              <Flex vertical style={{ rowGap: "16px" }}>
                <Row justify="space-between" align="middle">
                  <span style={{ fontSize: "18px", fontWeight: "bold", color: "#313131" }}>
                    {t("employee.label.deduction")}
                  </span>
                  <Button
                    disabled={!isAmountVisible} icon={<CreateIcon color="#344054" />}
                    onClick={() => onSetupIncomeDeduction("deduction")}
                    style={{ height: "44px", width: "44px", borderRadius: "8px" }}
                  />
                </Row>
                <ConfigProvider
                  theme={{
                    components: {
                      Table: {
                        headerBg: "#F1FBFC",
                        headerBorderRadius: "12px",
                        headerColor: "#667085",
                      },
                    },
                  }}
                >
                  <Table columns={columnDeduct} dataSource={dataDeduct} pagination={false} />
                </ConfigProvider>
              </Flex>
            </Card>
          </Col>
        </Row>
        <Row justify="end" style={{ gap: "12px" }}>
          {/* <Button type="default"
            style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content" }}>
            {t("common.cancel").toUpperCase()}
          </Button> */}
          <Button type="primary" htmlType="submit"
            onClick={() => {
              onSubmit({
                incomes: dataIncome,
                deductions: dataDeduct
              })
            }}
            disabled={!isAmountVisible}
            style={{ borderRadius: 8, padding: "8px 16px", width: "max-content", height: "max-content", backgroundColor: isAmountVisible ? "var(--button-color)" : null, color: isAmountVisible ? "white" : null }}
          >
            {t("common.submit").toUpperCase()}
          </Button>
        </Row>
      </Flex >
    )
  }, [dataDeduct, dataIncome, isAmountVisible, totalIncome, totalNetIncome])

  return (
    <Spin spinning={isLoading}>
      {getHistoryModal()}
      {getModal()}
      {getTable()}
    </Spin>
  );
}

export default EmployeeSalaryIncomDeduction;
